<div class="instance-selector-container">
  <div class="form-container">
    <h3 *ngIf="showTitle" class="instance-selector-label">{{ mainLabelKey | translate }}</h3>

    <tc-master-operator-connect-form
      [masterInstanceIds]="masterInstanceIds"
      [formControl]="control"
      [masterOperatorType]="masterOperatorType"
    ></tc-master-operator-connect-form>
  </div>
</div>
